import * as React from "react";
import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export default function OliverIcon(props: SvgIconProps) {
  const theme = useTheme();
  const color1 = theme.palette.primary.main;

  return (
    <SvgIcon {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="SVGIcon">
          <rect id="BG" fill="none" x="0" y="0" width="24" height="24"></rect>
          <g
            id="youngun"
            transform="translate(1.000000, 0.000000)"
            fillRule="nonzero"
          >
            <path
              d="M11,14.1055996 L6.92857301,10 C1.13789605,11.7963965 -0.396839226,12.987777 0.0819497664,13.9669938 C0.252225405,14.3153152 0.649732994,14.7882536 1.09446686,14.9026121 C3.01033477,15.3957177 7.10525624,13.8424933 11,14.1055996"
              id="Fill-31"
              fill={color1}
            ></path>
            <path
              d="M7,18 C5.64101267,17.7115228 4.36445785,15.9776588 4.04334449,13.8815414 C3.8230458,12.4441573 4.46182585,12.0525186 5.52023614,12 C5.66140538,14.1919013 6.18500971,16.2337495 7,18"
              id="Fill-32"
              fill="#995542"
            ></path>
            <path
              d="M20,18 C21.3589873,17.7115228 22.6355422,15.9776588 22.9566555,13.8815414 C23.1769542,12.4441573 22.5381742,12.0525186 21.4797639,12 C21.3385946,14.1919013 20.8149903,16.2337495 20,18 Z"
              id="Fill-33"
              fill="#995542"
            ></path>
            <path
              d="M20.7004888,7.67153125 C20.7891469,8.79590518 21,9.95292299 21,11.1632394 C21,18.2527778 17.4182828,24 13,24 C8.58171716,24 5,18.2527778 5,11.1632394 C5,9.27796626 5.2533254,7.48765718 5.70822031,5.8750495 C8.07506635,3.61336279 20.2965375,2.55653202 20.7004888,7.67153125"
              id="Fill-34"
              fill="#BC6957"
            ></path>
            <path
              d="M4.03642551,12 C3.96015404,10.5842799 4.00196903,7.96646456 4.17787229,5.75395477 C4.77449505,-1.75056225 18.7195592,-1.19758635 19.8868747,3.31460483 C20.3989331,5.29396999 20.7597334,7.84874047 20.9440464,9.48645115 C21.0217194,10.1775195 21.1123575,10.0787088 20.5076754,9.98644514 C18.103197,9.61884529 15.3234348,9.57192539 12.7327746,9.82895431 C9.97018221,10.1673353 6.45515379,11.0071652 4.03642551,12"
              id="Fill-35"
              fill={color1}
            ></path>
            <path
              d="M5.64972075,3.42819905 C6.41157228,1.77006882 7.86116349,0.613822776 10.5209429,0.207689413 C16.6729141,-0.729660703 17.98734,1.52778437 18.8253652,6.53525496 C19.2308613,8.95835799 19.064081,8.75716497 16.8650093,8.61735069 C15.339588,8.52030769 13.9529976,8.84412894 12.4282636,9.00293833 C10.3593172,9.26085821 7.86986906,10.1108567 5.94914638,10.8732451 C5.03918569,11.2345397 5.06072051,10.7975232 5.03380198,9.89221921 C4.9664484,7.63244821 4.92830427,4.99833157 5.64972075,3.42819905 Z"
              id="Fill-36"
              fill={color1}
            ></path>
            <path
              d="M9.23238013,11.0905109 C11.1449838,10.7757856 12.879336,11.3061167 13.417278,12.304401 C13.9794196,11.3215931 15.7450543,10.8016583 17.6910654,11.1131939 C19.9405764,11.4734032 21.2317787,12.6080212 20.9654638,14.5484733 C20.437792,18.3912181 14.560803,17.2651061 13.4101951,14.2691899 C12.2765861,17.2687684 6.54857287,18.392045 6.03376823,14.539022 C5.77347375,12.5911272 7.03492809,11.452138 9.23238013,11.0905109"
              id="Fill-37"
              fill="#E8B003"
            ></path>
            <path
              d="M9.60863276,11.0754448 C11.3819943,10.7741151 12.9657213,11.4021211 13.1132149,12.4833004 C13.571776,15.843197 7.50590567,17.6486994 7.02727215,13.9490406 C6.81712143,12.3257979 7.83516028,11.3766566 9.60863276,11.0754448 Z M17.391307,11.0754448 C15.6179454,10.7741151 14.0342185,11.4021211 13.8867248,12.4833004 C13.4281638,15.843197 19.494034,17.6486994 19.9727785,13.9490406 C20.1827074,12.3257979 19.1647794,11.3766566 17.391307,11.0754448 L17.391307,11.0754448 Z"
              id="Fill-38"
              fill="#577BA5"
            ></path>
            <path
              d="M9.89607416,11.0623303 C10.3132404,11.0860412 10.5958494,11.1409837 10.6458425,11.4158006 C10.8954226,12.7895717 8.6295388,14.0779 7.16714349,13.9963219 C6.60937957,13.9651948 6.12512739,13.8905106 6.02501262,13.3130922 C5.93453663,12.7918697 6.08580118,12.2871509 6.5394663,11.8971219 C7.2924476,11.250033 8.84236301,11.0021651 9.89607416,11.0623303 Z M16.2376187,11.005821 C17.1236151,10.939702 17.137752,11.4485989 16.7829164,11.9353518 C16.4098315,12.447069 15.5356586,12.8151628 14.8632575,12.880864 C14.3576715,12.9302705 14.0467888,12.9273458 13.9600398,12.4230447 C13.9060627,12.1094756 14.018258,11.8799915 14.2494602,11.6687867 C14.7233025,11.2358274 15.5476107,11.057212 16.2376187,11.005821 L16.2376187,11.005821 Z"
              id="Fill-39"
              fill="#6E9CD4"
            ></path>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
